{
  "version": 1,
  "asset_id": "fa9eb929-0fe2-468d-9fe6-a03a6562b9a5",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/fa9eb929-0fe2-468d-9fe6-a03a6562b9a5/esenyurt-hizli-elektrikci-7-24-dukkan-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/fa9eb929-0fe2-468d-9fe6-a03a6562b9a5/esenyurt-hizli-elektrikci-7-24-dukkan-5.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-5.jpg",
  "size": 622189,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:14Z"
}
